module.exports = __webpack_public_path__ + "img/lantern-off.2beceb12.png";